import * as api from '@gitbook/api-client';

import { NavigationIntegrationsProvider } from './schema';

/**
 * Safely parse category param passed in the URL to avoid unrelevant values.
 */
export function parseIntegrationCategoryParam(
    value: string | null | undefined
): api.IntegrationCategory | undefined {
    switch (value) {
        case api.IntegrationCategory.Analytics:
        case api.IntegrationCategory.Collaboration:
        case api.IntegrationCategory.Content:
        case api.IntegrationCategory.Marketing:
        case api.IntegrationCategory.Other:
        case api.IntegrationCategory.VisitorAuth:
            return value;
        default:
            return undefined;
    }
}

/**
 * Safely parse integrations provider param passed in the URL to avoid unrelevant values.
 */
export function parseNavigationIntegrationsProviderParam(
    value: string | null | undefined
): NavigationIntegrationsProvider | undefined {
    switch (value) {
        case NavigationIntegrationsProvider.Organization:
            return value;
        default:
            return undefined;
    }
}

/**
 * Safely parse install status param passed in the URL to avoid unrelevant values.
 */
export function parseIntegrationModalStateParam(
    value: string | null | undefined
): 'configure' | undefined {
    return value === 'configure' ? value : undefined;
}
